import { v4 as uuidv4 } from 'uuid';
import { GymCatDB } from '@/repository/database';
import { Module, Mutation, ActionHandler } from 'vuex';
import { RootState } from './root.store';
import { ExerciseActivity } from '@/models/exercise-activity.model';

export interface ExerciseActivityState {
  exerciseActivities: ExerciseActivity[];
}

export const EXERCISE_ACTIVITY_ADD_MUTATION = 'EXERCISE_ACTIVITY_ADD_MUTATION';
export const EXERCISE_ACTIVITY_ADD_HANDLER: Mutation<ExerciseActivityState> = (
  state,
  exerciseActivity: ExerciseActivity,
) => {
  state.exerciseActivities = [...state.exerciseActivities, exerciseActivity];
};

export const EXERCISE_ACTIVITY_EDIT_MUTATION = 'EXERCISE_ACTIVITY_EDIT_MUTATION';
export const EXERCISE_ACTIVITY_EDIT_HANDLER: Mutation<ExerciseActivityState> = (
  state,
  exerciseActivity: ExerciseActivity,
) => {
  const index = state.exerciseActivities.findIndex(e => e.id === exerciseActivity.id);
  if (index > -1) {
    state.exerciseActivities[index] = exerciseActivity;
  } else {
    throw new Error(`Exercise ${exerciseActivity.id} not found`);
  }
};

export const EXERCISE_ACTIVITY_LOAD_ALL_MUTATION = 'EXERCISE_ACTIVITY_LOAD_ALL_MUTATION';
export const EXERCISE_ACTIVITY_LOAD_ALL_HANDLER: Mutation<ExerciseActivityState> = (
  state,
  exerciseActivities: ExerciseActivity[],
) => {
  state.exerciseActivities = exerciseActivities;
};

export const EXERCISE_ACTIVITY_LOAD_SINGLE_MUTATION = 'EXERCISE_ACTIVITY_LOAD_SINGLE_MUTATION';
export const EXERCISE_ACTIVITY_LOAD_SINGLE_HANDLER: Mutation<ExerciseActivityState> = (
  state,
  exerciseActivity: ExerciseActivity,
) => {
  state.exerciseActivities = [...state.exerciseActivities, exerciseActivity];
};

export const EXERCISE_ACTIVITY_DELETE_MUTATION = 'EXERCISE_ACTIVITY_DELETE_MUTATION';
export const EXERCISE_ACTIVITY_DELETE_HANDLER: Mutation<ExerciseActivityState> = (state, id: string) => {
  state.exerciseActivities = state.exerciseActivities.filter(e => e.id !== id);
};

export const EXERCISE_ACTIVITY_ADD_ACTION = 'EXERCISE_ACTIVITY_ADD_ACTION';
export const EXERCISE_ACTIVITY_ADD_HANDLER_ASYNC: ActionHandler<ExerciseActivityState, RootState> = async (
  { commit },
  { database, exerciseActivity }: { database: GymCatDB; exerciseActivity: ExerciseActivity },
) => {
  const id = uuidv4();
  const entity: ExerciseActivity = {
    ...exerciseActivity,
    id,
    created: new Date(),
  };
  commit(EXERCISE_ACTIVITY_ADD_MUTATION, entity);
  await database.exerciseActivities.add(entity);
};

export const EXERCISE_ACTIVITY_EDIT_ACTION = 'EXERCISE_ACTIVITY_EDIT_ACTION';
export const EXERCISE_ACTIVITY_EDIT_HANDLER_ASYNC: ActionHandler<ExerciseActivityState, RootState> = async (
  { commit },
  { database, exerciseActivity }: { database: GymCatDB; exerciseActivity: ExerciseActivity },
) => {
  const entity: ExerciseActivity = {
    ...exerciseActivity,
    modified: new Date(),
  };
  commit(EXERCISE_ACTIVITY_EDIT_MUTATION, entity);
  await database.exerciseActivities.update(entity.id, entity);
};

export const EXERCISE_ACTIVITY_LOAD_ALL_ACTION = 'EXERCISE_ACTIVITY_LOAD_ALL_ACTION';
export const EXERCISE_ACTIVITY_LOAD_ALL_HANDLER_ASYNC: ActionHandler<ExerciseActivityState, RootState> = async (
  { commit },
  database: GymCatDB,
) => {
  const exerciseActivities = await database.exerciseActivities.orderBy('created').toArray();
  commit(EXERCISE_ACTIVITY_LOAD_ALL_MUTATION, exerciseActivities);
};

export const EXERCISE_ACTIVITY_LOAD_SINGLE_ACTION = 'EXERCISE_ACTIVITY_LOAD_SINGLE_ACTION';
export const EXERCISE_ACTIVITY_LOAD_SINGLE_HANDLER_ASYNC: ActionHandler<ExerciseActivityState, RootState> = async (
  { state, commit },
  { id, database }: { id: string; database: GymCatDB },
) => {
  const existing = state.exerciseActivities.find(e => e.id === id);
  if (existing) {
    return existing;
  }
  const exerciseActivity = await database.exerciseActivities.get(id);
  commit(EXERCISE_ACTIVITY_LOAD_SINGLE_MUTATION, exerciseActivity);
  return exerciseActivity;
};

export const EXERCISE_ACTIVITY_DELETE_ACTION = 'EXERCISE_ACTIVITY_DELETE_ACTION';
export const EXERCISE_ACTIVITY_DELETE_HANDLER_ASYNC: ActionHandler<ExerciseActivityState, RootState> = async (
  { commit },
  { id, database }: { id: string; database: GymCatDB },
) => {
  commit(EXERCISE_ACTIVITY_DELETE_MUTATION, id);
  await database.exerciseActivities.delete(id);
};

export const exerciseActivityModule: Module<ExerciseActivityState, RootState> = {
  state: {
    exerciseActivities: [],
  },
  mutations: {
    [EXERCISE_ACTIVITY_ADD_MUTATION]: EXERCISE_ACTIVITY_ADD_HANDLER,
    [EXERCISE_ACTIVITY_EDIT_MUTATION]: EXERCISE_ACTIVITY_EDIT_HANDLER,
    [EXERCISE_ACTIVITY_LOAD_ALL_MUTATION]: EXERCISE_ACTIVITY_LOAD_ALL_HANDLER,
    [EXERCISE_ACTIVITY_LOAD_SINGLE_MUTATION]: EXERCISE_ACTIVITY_LOAD_SINGLE_HANDLER,
    [EXERCISE_ACTIVITY_DELETE_MUTATION]: EXERCISE_ACTIVITY_DELETE_HANDLER,
  },
  actions: {
    [EXERCISE_ACTIVITY_ADD_ACTION]: EXERCISE_ACTIVITY_ADD_HANDLER_ASYNC,
    [EXERCISE_ACTIVITY_EDIT_ACTION]: EXERCISE_ACTIVITY_EDIT_HANDLER_ASYNC,
    [EXERCISE_ACTIVITY_LOAD_ALL_ACTION]: EXERCISE_ACTIVITY_LOAD_ALL_HANDLER_ASYNC,
    [EXERCISE_ACTIVITY_LOAD_SINGLE_ACTION]: EXERCISE_ACTIVITY_LOAD_SINGLE_HANDLER_ASYNC,
    [EXERCISE_ACTIVITY_DELETE_ACTION]: EXERCISE_ACTIVITY_DELETE_HANDLER_ASYNC,
  },
  modules: {},
  getters: {
    // getExerciseById: state => (id: string) =>
    //   state.exercises.find(e => e.id === id),
  },
};
